/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/data_structures/KavenLinkedListNode.ts
 * @create:      2019-03-21 18:03:33.111
 * @modify:      2020-02-18 15:38:03.933
 * @version:     2.0.4
 * @times:       14
 * @lines:       90
 * @copyright:   Copyright © 2019 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Represents a node in a __KavenLinkedList__. This class cannot be inherited.
 * @since 1.1.19
 * @version 2019-03-22
 */
export class KavenLinkedListNode<T> {
    protected value: T;

    protected next?: KavenLinkedListNode<T>;
    protected prev?: KavenLinkedListNode<T>;

    /**
     * Initializes a new instance of the KavenLinkedListNode class, containing the specified value.
     * @param value The value to contain in the KavenLinkedListNode.
     */
    public constructor(value: T) {
        this.value = value;
    }

    /**
     * Gets the next node in the KavenLinkedList.
     */
    public get Next() {
        return this.next;
    }

    public set Next(value: KavenLinkedListNode<T> | undefined) {
        this.next = value;
    }

    /**
     * Gets the previous node in the KavenLinkedList.
     */
    public get Prev() {
        return this.prev;
    }

    public set Prev(value: KavenLinkedListNode<T> | undefined) {
        this.prev = value;
    }

    /**
     * Gets the value contained in the node.
     */
    public get Value() {
        return this.value;
    }

    public set Value(value: T) {
        this.value = value;
    }

    public Clear() {
        this.next = undefined;
        this.prev = undefined;
    }
}
